module.exports = __webpack_public_path__ + "static/media/logo-marajasena.2c3525dd.png";